import { SET_LOGGEDIN, SET_TOKEN, SET_USER_DETAILS, SET_MENU_ITEMS, SET_SELLERCREATION, SET_ACCOUNTTYPE, SET_BUYNOWPRODUCTS, SET_ACCOUNT_DETAILS, SET_REGION, SET_CURRENT_DELIVERY_ADDRESS } from "./constants";

export const setLoggedIn = (value) => {
    if (!value) {
        localStorage.removeItem('token')
    }
    return {
        type: SET_LOGGEDIN,
        payload: value
    }
}

export const setToken = value => ({
    type: SET_TOKEN,
    payload: value
})

export const setUserDetails = value => ({
    type: SET_USER_DETAILS,
    payload: value
})

export const setMenuItems = value => ({
    type: SET_MENU_ITEMS,
    payload: value
})

export const setSellerCreation = value => ({
    type: SET_SELLERCREATION,
    payload: value
})

export const setAccountType = value => ({
    type: SET_ACCOUNTTYPE,
    payload: value
})

export const setBuyNowProducts = value => ({
    type: SET_BUYNOWPRODUCTS,
    payload: value
})

export const setAccountDetails = value => ({
    type: SET_ACCOUNT_DETAILS,
    payload: value
})

export const setRegions = value => ({
    type: SET_REGION,
    payload: value
})

export const setCurrentDeliveryAddress = value => ({
    type: SET_CURRENT_DELIVERY_ADDRESS,
    payload: value
})